import { render, staticRenderFns } from "./BotSelector.vue?vue&type=template&id=48cd1aa3&scoped=true&"
import script from "./BotSelector.vue?vue&type=script&lang=js&"
export * from "./BotSelector.vue?vue&type=script&lang=js&"
import style0 from "./BotSelector.vue?vue&type=style&index=0&id=48cd1aa3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cd1aa3",
  null
  
)

export default component.exports